import { Box } from "@mui/material";
import React from "react";
import styled from "styled-components";
import CesiumMap from "../components/CesiumMap";
import Drawer from "../components/Drawer";

import SpaceModePopup from "../components/Drawer/sideMenu/SpaceModePopup";
import Timeline from "../components/Timeline";
import useCommonDataStore from "../stores/common.store";

const Slider = styled.div`
  position: absolute;
  left: 50%;
  top: 0px;
  background-color: #d3d3d3;
  width: 5px;
  height: 100%;
  z-index: 10;
  &:hover {
    cursor: ew-resize;
  }
`;

export default function MainPage() {
  const { commonData } = useCommonDataStore();
  const sliderRef = React.useRef(null);

  return (
    <Box
      sx={{
        width: "100dvw",
        height: "100dvh",
      }}
    >
      <Timeline sliderRef={sliderRef} />
      <CesiumMap>
        <Slider
          ref={sliderRef}
          style={{
            visibility: commonData.slider ? "visible" : "hidden",
          }}
        />
      </CesiumMap>
      <Drawer />
      {/* <Box
        sx={{
          position: "absolute",
          bottom: "0",
          right: "0",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          padding: "10px",
          borderRadius: "5px",
        }}
      >
        {JSON.stringify(commonData)}
      </Box> */}
      <SpaceModePopup />
    </Box>
  );
}
